import { render, staticRenderFns } from "./operMessIndex.vue?vue&type=template&id=35c9b612&scoped=true"
import script from "./operMessIndex.vue?vue&type=script&lang=js"
export * from "./operMessIndex.vue?vue&type=script&lang=js"
import style0 from "./operMessIndex.vue?vue&type=style&index=0&id=35c9b612&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c9b612",
  null
  
)

export default component.exports